import CONFIG_ENVS from './config-envs.json'

const IS_LOCAL = process.env.REACT_APP_ENV === 'local'
const IS_STAGE = process.env.REACT_APP_ENV === 'stage'
const IS_PROD = !IS_STAGE && !IS_LOCAL

export default {
  IS_LOCAL,
  IS_PROD,
  IS_STAGE,
  TRACK: {
    DATADOG: CONFIG_ENVS.DATADOG,
  },
}
